import React, { useState, useEffect, } from 'react';
import { useTranslation } from 'react-i18next';
import { InputLabel, Ornanizationlistcontainer } from '../../components/Modals/styles';
import { Button, Select, Modal } from 'antd';
import { SELECT_CLIENT_MODAL } from './translationValues';
import { fetchAllOrganizationDetails } from '../../utils/services/authAPI';

const { Option } = Select;
const NAMESPACES = ['SELECT_CLIENT_MODAL'];
const SelectOrganizatoin = ({ onCancel, handleClick, visible, organizationId }) => {
    const { t } = useTranslation(NAMESPACES);

    const [organizationList, setOranizationList] = useState([]);
    const [ornanizationName, setOranizationName] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            const response = await fetchAllOrganizationDetails();
            setOranizationList(response?.data);
            setOranizationName('All')
            if (!['All', 'DEFAULT'].includes(organizationId)) {
                const result = response?.data.filter((list) => list.organizationId === organizationId);
                setOranizationName(result[0]);
            };
            setLoading(false)
        })();
    }, [])

    const selectData = (value) => {
        setOranizationName(JSON.parse(value));
    };

    return (
        <Modal
            width="580px"
            centered
            closable={false}
            visible={visible}
            onCancel={() => onCancel()}
            className="clientList-modal"
            footer={[
                <Button key='black' onClick={() => onCancel()} className="cancel">
                    {t(
                        SELECT_CLIENT_MODAL.CANCEL_BUTTON.key,
                        SELECT_CLIENT_MODAL.CANCEL_BUTTON.value,
                    )}
                </Button>,
                <Button onClick={() => handleClick(ornanizationName)} className='confirm'>
                    {t(
                        SELECT_CLIENT_MODAL.CONFIRM_BUTTON.key,
                        SELECT_CLIENT_MODAL.CONFIRM_BUTTON.value,
                    )}
                </Button>,
            ]}
        >
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <InputLabel ornanizationlist>
                    {t(
                        SELECT_CLIENT_MODAL.CLIENT_MODAL_HEADER.key,
                        SELECT_CLIENT_MODAL.CLIENT_MODAL_HEADER.value,
                    )}
                </InputLabel>
                <InputLabel ornanizationlist normal>
                    {t(
                        SELECT_CLIENT_MODAL.CLIENT_MODAL_DESC.key,
                        SELECT_CLIENT_MODAL.CLIENT_MODAL_DESC.value,
                    )}
                </InputLabel>
                <Ornanizationlistcontainer>
                    <InputLabel normal>
                        {t(
                            SELECT_CLIENT_MODAL.CLIENT_LABEL.key,
                            SELECT_CLIENT_MODAL.CLIENT_LABEL.value,
                        )}
                    </InputLabel>

                    <Select
                        loading={loading}
                        showSearch
                        value={JSON.stringify(ornanizationName)}
                        style={{ width: "100%" }}
                        placeholder="Select Category"
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={value => selectData(value)}
                    >
                        <Option key="all" value={JSON.stringify('All')}>
                            All
                        </Option>
                        {organizationList.length > 0 &&
                            organizationList.filter(list => (list.email !== null)).map(data => (
                                <Option key={data.organizationId} value={JSON.stringify(data)}>
                                    {data.email}
                                </Option>
                            ))}
                    </Select>
                </Ornanizationlistcontainer>
            </div>
        </Modal>
    )
};

export default SelectOrganizatoin;